import axiosStatic, {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios';
import { API_HOST, API_NAMESPACE, API_VERSION } from 'config/environment';
import { axios } from './axios';

const getMockApi = async () => {
  try {
    const path = 'mock';
    const mock = await import(`../${path}.json`);

    return mock.apis;
  } catch (e) {
    return [];
  }
};

abstract class HttpClient {
  private _api: AxiosInstance;

  protected api = () => this._api;

  /**
   * this base url is used to generate download url
   * for project files.
   * these download urls will be set as href for anchor tags.
   */
  protected BASEURL = `${API_HOST}/${API_NAMESPACE}/${API_VERSION}`;

  protected MockBase = 'http://localhost:4000';

  private mockApis: string[] = [];

  public constructor() {
    this._api = axiosStatic.create({
      baseURL: this.BASEURL,
    });
    axios().subscribe((client) => {
      this._api = client;
    });
    getMockApi().then((api) => {
      this.mockApis = api;
    });
  }

  public get = <T, R = T>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<R> => {
    const actualUrl =
      this.mockApis.includes(url) &&
      window.location.hostname.includes('localhost') &&
      !window?.Cypress
        ? `${this.MockBase}${url}`
        : url;

    return this.api()
      .get(actualUrl, config)
      .then((x) => x.data);
  };

  public getResponse = <T, R = T>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<R>> => {
    const actualUrl =
      this.mockApis.includes(url) &&
      window.location.hostname.includes('localhost') &&
      !window?.Cypress
        ? `${this.MockBase}${url}`
        : url;

    return this.api()
      .get(actualUrl, config)
      .then((x) => x);
  };

  public post = <T, B, R = T>(
    url: string,
    payload?: B,
    config?: AxiosRequestConfig,
  ): Promise<R> =>
    this.api()
      .post(url, payload, config)
      .then((x) => x.data);

  public put = <T, B, R = T>(
    url: string,
    payload?: B,
    config?: AxiosRequestConfig,
  ): Promise<R> =>
    this.api()
      .put(url, payload, config)
      .then((x) => x.data);

  public patch = <T, B, R = T>(
    url: string,
    payload?: B,
    config?: AxiosRequestConfig,
  ): Promise<R> =>
    this.api()
      .post(url, payload, config)
      .then((x) => x.data);

  public delete = <T, R = T>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<R> =>
    this.api()
      .delete(url, config)
      .then((x) => x.data);
}

export { HttpClient };
